import ReactGA from "react-ga";

export const initGA = (trackingID: string | undefined) => {
  if (trackingID) ReactGA.initialize(trackingID);
};

export const GA_Event = (category: string, action: string, label?: string) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

export const GA_PageView = (route?: string) => {
  ReactGA.pageview(
    route ||
      `${window.location.pathname}${window.location.hash}${window.location.search}`
  );
};
